import { create } from 'zustand';

export const useVideoStore = create((set, get) => ({
  // 视频状态
  videoFile: null,
  isPlaying: false,
  currentTime: 0,
  duration: 0,
  playbackRate: 1,
  volume: 1,

  // 设置视频文件
  setVideoFile: (file) => set({ 
    videoFile: file,
    currentTime: 0,
    duration: 0,
    isPlaying: false
  }),

  // 播放控制
  setIsPlaying: (playing) => set({ isPlaying: playing }),
  
  togglePlay: () => set((state) => ({ isPlaying: !state.isPlaying })),

  // 时间控制
  setCurrentTime: (time) => set({ currentTime: time }),
  
  setDuration: (duration) => set({ duration }),

  // 播放速度控制
  setPlaybackRate: (rate) => set({ playbackRate: rate }),

  // 音量控制
  setVolume: (volume) => set({ volume }),

  // 跳转到指定时间
  seekTo: (time) => {
    const { duration } = get();
    const clampedTime = Math.max(0, Math.min(time, duration));
    set({ currentTime: clampedTime });
    return clampedTime;
  },

  // 格式化时间显示
  formatTime: (time) => {
    if (!time || isNaN(time)) return '00:00.000';
    
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    const milliseconds = Math.floor((time % 1) * 1000);
    
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(3, '0')}`;
  },

  // 重置视频状态
  reset: () => set({
    videoFile: null,
    isPlaying: false,
    currentTime: 0,
    duration: 0,
    playbackRate: 1,
    volume: 1
  })
}));